import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

export const api = {
  me: () => client.get("/auth/me"),
  session: (session_id, referred_by) => client.post("/auth/session", { session_id, referred_by }),
  logout: () => client.post("/auth/logout"),
  subscription: () => client.get("/subscription"),
  referral: () => client.get("/referral"),
  generate: (payload) => client.post("/ai/generate", payload),
  evolve: (plan, lang) => client.post("/ai/evolve", { plan, lang }),
  aiJob: (id) => client.get(`/ai/job/${id}`),
  savePlan: (plan) => client.post("/plans", plan),
  listPlans: () => client.get("/plans"),
  getPlan: (id) => client.get(`/plans/${id}`),
  deletePlan: (id) => client.delete(`/plans/${id}`),
  checkout: (lookup_key, origin_url) => client.post("/payments/checkout", { lookup_key, origin_url }),
  paymentStatus: (session_id) => client.get(`/payments/status/${session_id}`),
  createLog: (log) => client.post("/logs", log),
  listLogs: () => client.get("/logs"),
  deleteLog: (id) => client.delete(`/logs/${id}`),
  getSchedule: () => client.get("/schedule"),
  putSchedule: (entries) => client.put("/schedule", { entries }),
};

export default client;

export async function pollAiJob(job_id, { interval = 2500, timeout = 150000 } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeout) {
    const { data } = await client.get(`/ai/job/${job_id}`);
    if (data.status === "done") return data.plan;
    if (data.status === "error") throw new Error(data.error || "Errore");
    await new Promise((r) => setTimeout(r, interval));
  }
  throw new Error("Timeout");
}
